import api from "./api";

const BASE_ENDPOINT = '/percentuais-financeiros';

function getPercents() {
    return api.get(`${BASE_ENDPOINT}`);
}

function updatePercents(percentuais) {
    return api.put(`${BASE_ENDPOINT}/update`, percentuais);
}

function getPercentsHistory(){
    return api.get(`${BASE_ENDPOINT}/history`);      
}

const PercentuaisApiService = {
    getPercents,
    updatePercents,
    getPercentsHistory
}

export default PercentuaisApiService;